import { Component } from 'react'
import moment from 'moment-timezone'
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import de from "date-fns/locale/de";
// import en from "date-fns/locale/en-gb";

class EditEventFormDatePicker extends Component {
    constructor(props) {
        super(props);

        if("de-DE" === props.locale) {
            registerLocale("de-DE", de);
        }

        // if("en-GB" === props.locale) {
        //     registerLocale("en-GB", en);
        // }
    }

    formatWithoutZone(momentDate) {
        return momentDate.format("YYYY-MM-DDTHH:mm:ss.SSS")
    }

    formatZone(momentDate) {
        return momentDate.format("Z")
    }

    mergeDateWithZone(dateWithoutZone, otherZone) {
        return [dateWithoutZone, otherZone].join("")
    }

    getDatepickerDate(dateString) {
        const { timezone } = this.props 

        if(!dateString) {
            return dateString
        }
    
        const dateWithoutZone = this.formatWithoutZone(moment.tz(dateString, timezone))
        const otherZone = this.formatZone(moment(dateString))
        const dateWithOtherZone = this.mergeDateWithZone(dateWithoutZone, otherZone)
    
        return new Date(dateWithOtherZone)
    }

    setDatepickerDateObject(dateString) {
        const { timezone, dateTypes } = this.props

        if(!dateString) {
            return {
                day : "",
                date: dateString
            }
        }
    
        const dateWithoutZone = this.formatWithoutZone(moment(dateString).startOf("day"))
        const otherZone = this.formatZone(moment.tz(dateString, timezone))
        const dateWithOtherZone = this.mergeDateWithZone(dateWithoutZone, otherZone)
    
        return {
            day: dateTypes.order[moment(dateString).isoWeekday() - 1],
            date: dateWithOtherZone,
        }

    }

    setDatepickerDate(dateString) {
        const { timezone, dateTypes } = this.props

        if(!dateString) {
            return dateString
        }
    
        const dateWithoutZone = this.formatWithoutZone(moment(dateString).startOf("day"))
        const otherZone = this.formatZone(moment.tz(dateString, timezone))
        const dateWithOtherZone = this.mergeDateWithZone(dateWithoutZone, otherZone)

        return dateWithOtherZone
    }

    getDatePickerTime(timeString) {
        const { timezone } = this.props 

        if(!timeString) {
            return timeString
        }
    
        const dateWithoutZone = this.formatWithoutZone(moment.tz(timeString, timezone))
        const otherZone = this.formatZone(moment(timeString))
        const dateWithOtherZone = this.mergeDateWithZone(dateWithoutZone, otherZone)
    
        return new Date(dateWithOtherZone)
    }

    setDatePickerTime(timeString) {
        const { timezone } = this.props 
        const timeWithoutZone = moment(timeString).millisecond(0).format("YYYY-MM-DDTHH:mm:ss.SSS")
        const otherZone = this.formatZone(moment.tz(timeString, timezone))
        const timeWithOtherZone = this.mergeDateWithZone(timeWithoutZone, otherZone)

        return timeWithOtherZone
    }

    setTimeWithNewDate(dateString, timeValue) {
        const { timezone } = this.props 
        const newDate = moment.tz(this.setDatepickerDate(dateString), timezone)
        const time = moment.tz(timeValue, timezone)

        return time.date(newDate.date()).month(newDate.month()).year(newDate.year()).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    }

    getValue(type) {
        const { name, values } = this.props

        const value = "date" === name ? values.date.date : values[name]

        if('date' === type) {
            return this.getDatepickerDate(value)
        } else {
            return this.getDatePickerTime(value)
        }
    }

    setValue(d, type) {
        const { name, values, setFieldValue, setActiveField } = this.props

        if('date' === type) {
            if('date' === name) {
                const { event_time_start, event_time_end} = values 

                setFieldValue(name,  this.setDatepickerDateObject(d), true)

                event_time_start && setFieldValue('event_time_start', this.setTimeWithNewDate(d, event_time_start), true)
                event_time_end && setFieldValue('event_time_end', this.setTimeWithNewDate(d, event_time_end), true)
            } else {
                setFieldValue(name,  this.setDatepickerDate(d), true)
            }
        } else {
            setFieldValue(name, this.setDatePickerTime(d), true)
        }

        setActiveField('')
    }

    render()  {
        const { pickerType, locale } = this.props

        return 'date' === pickerType ? (
            <DatePicker                       
                placeholderText="Bitte Datum auswählen"
                selected={this.getValue('date')}
                dateFormat="dd.MM.yyyy"
                autoComplete="off"
                locale={locale}
                onChange={(d) => {
                    this.setValue(d, 'date')
                }}
            />
        ) : (
            <DatePicker
                placeholderText="Bitte Uhrzeit auswählen"
                selected={this.getValue('time')}
                dateFormat="HH:mm"
                locale={locale}
                showTimeSelect
                showTimeSelectOnly
                timeCaption="Uhrzeit"
                timeIntervals={60}
                onChange={(t) => {
                    this.setValue(t, 'time')
                }}
            />
        )
    }
}

export default EditEventFormDatePicker